import { OptionBar } from '@boschebike/ebds-react';
import { FunctionComponent, PropsWithChildren, useContext } from 'react';
import { RoutingContext } from '../../../context/routingContext';
import { PageNavigationProps } from '../types';

export const PageNavigationDesktop: FunctionComponent<PropsWithChildren<PageNavigationProps>> = ({ links }) => {
  const { activeTab, setTab } = useContext(RoutingContext);
  const selectedOption = links.find((l) => l.route === activeTab)?.text ?? '';
  const selectionOptions: string[] = links.map((s) => (s.text)).filter((s) => s.length > 0);

  return (
    <nav id="ebds-navigation-switch">
      {selectedOption.length
        ? (
          <OptionBar
            options={selectionOptions}
            defaultOption={selectedOption}
            onChange={(newValue: string) => {
              const selectedTab = links.find((l) => l.text === newValue)?.route ?? '';
              setTab(selectedTab);
            }}
          />
        ) : null}
    </nav>
  );
};
